import axios from 'axios'
import CartManager from '../../cart/cart-manager'
import getDataAttributeValue from '../../attributes/attributes'
import VARIANTS_TYPES from '../../filter-variants/components/config/variants-config'
import quantityInput from '../../filter-variants/components/resultsTable/cartForm/quantityInput'

const attributesDropdownsElement = '.new-product-view.swr #attributes-dropdowns'

export default class CartFormSWR {
    constructor(props) {
        this.props = props
        this.observer = props.observer
        this.formElem = document.createElement('form')
        this.messageElem = document.createElement('div')
        this.addButtonElem = document.createElement('button')
        this.loginButtonElem = document.createElement('a')
        this.quantityElem = document.createElement('div')
        this.canCreateOrder = props.data.options.canCreateOrder
        this.isGuestActive = props.data.options.isGuestActive
        this.isLogged = props.data.options.isLogged
        this.isWebshopActive = props.data.options.isWebshopActive
        this.isRFQActive = props.data.options.isRFQActive
        this.hideLoginWidget = props.data.options.hideLoginWidget
        this.isSwr = props.data.options.isSwr
        this.showAddToCart = props.data.options.showAddToCart
        this.showAddToQuote = props.data.options.showAddToQuote
        this.showTotalPrice = props.data.options.showTotalPrice
        this.price = null
        this.unitPrice = null
        this.batchPrice = null
        this.packQty = 0
        this.ropeLength = 1
        this.currencyCode = ''
        this.priceTotal = null
        this.id = ''
        this.priceOptionsElem = null
        
        this.contactURL = getDataAttributeValue(attributesDropdownsElement, 'data-contact-url')
        this.actionURL = getDataAttributeValue(attributesDropdownsElement, 'data-action-url')
        this.loginURL = getDataAttributeValue(attributesDropdownsElement, 'data-login-url')
        this.infoDiv = document.createElement('div')
        this.addRentalButton = document.createElement('button')
        this.IsRentalBtn = false
        this.allowDecimalQuantity = getDataAttributeValue('.new-product-card', 'data-allow-decimal')
        this.quantity = this.allowDecimalQuantity ? 1.0 : 1
        this._packageSelected = false
    }

    getLocaleCode() {
        return document.querySelector('html').getAttribute('data-locale').replace('_', '-')
    }

    getFormatedPrice() {
        if(this.price != 'undefined' && this.price != null && this.price != 'N/A' && this.price > 0)
        {
            return new Intl.NumberFormat(this.getLocaleCode(), {
                style: 'currency',
                currency: this.currencyCode,
            }).format(this.priceTotal)
        }
        else
        {
            return 'N/A';
        }
    }

    isLoginPopupActive() {
        let productElem = document.querySelector('.new-product-card')
        return productElem.getAttribute('data-popup-login') || 0
    }

    updateMessage(type) {
        let tmpl = ''
        if (type === VARIANTS_TYPES.PRICE && this.showTotalPrice) {
            if (this.packQty > 1) {
                const isPackage = this.isPackageSelected()
                tmpl = `
                    <label class="npp__price-option npp__price-option--single d-flex align-items-center">
                        <input type="radio" name="price_option" value="single" class="npp__price-radio"${!isPackage ? ' checked' : ''}>&nbsp;
                        <div>
                            <span class='price-label'>${window.globals.trans('filter.total_price')}: </span>
                            <span class='price-value'> ${isPackage ? this.formatRawPrice(this.unitPrice * this.ropeLength) : this.getFormatedPrice()}</span>
                        </div>
                    </label>
                    <label class="npp__price-option npp__price-option--package d-flex align-items-center">
                        <input type="radio" name="price_option" value="package" class="npp__price-radio" data-pack-qty="${this.packQty}"${isPackage ? ' checked' : ''}>&nbsp;
                        <div>
                            <span class='price-label'>${window.globals.trans('product-page.full-package')} (${this.packQty} ${window.globals.trans('product-page.pieces')}):</span>
                            <span class='batch-price-value'> ${isPackage ? this.getFormatedPrice() : this.formatRawPrice(this.unitPrice * this.packQty * this.ropeLength)}</span>
                        </div>
                    </label>
                    <div class='alert alert-info'>${window.globals.trans('cart.swr_endings_additional_cost')}</div>
                    `
            } else {
                tmpl = `<span class='price-label l2'>${window.globals.trans('filter.total_price')}: </span>
                <span class='price-value'> ${this.getFormatedPrice()}</span>
                <div class='alert alert-info'>${window.globals.trans('cart.swr_endings_additional_cost')}</div>`
            }
        } else if (type === VARIANTS_TYPES.NO_PRICE) {
            tmpl = `<span class='price-value l3'></span><span class='price-description'>${window.globals.trans('filter.no_price_info')}</span>`
        } else if (type === VARIANTS_TYPES.DEFAULT) {
            tmpl = `<span class='price-value l4'></span><span class='price-description'>${window.globals.trans('filter.cart_info_swr')}</span>`
        } else if (type === VARIANTS_TYPES.LOADING){
            tmpl = `<span class='price-label l5'>${window.globals.trans('filter.total_price')}: </span>
            <span class='price-value'><div class="loader"></div></span>`
        }
        this.messageElem.innerHTML = tmpl
    }

    setPrice(price) {
        if (typeof price === 'string') {
            this.price = price.replaceAll(',', '.')
        } else {
            this.price = price
        }
        this.calculatePrice(this.price)
    }

    calculatePrice() {
        if(this.price != 'undefined' && this.price != null && this.price != 'N/A' && this.price > 0)
        {
            this.priceTotal = (this.price * this.quantity * this.ropeLength).toFixed(2)
        }
        else
        {
            this.priceTotal = 'N/A';
        }
    }

    setQuantity(qty, isFastBuyForm = false) {
        if (typeof qty === 'string') {
            qty = qty.replace(',', '.')
        }

        const parsedQty = parseFloat(qty)
        this.quantity = (!isNaN(parsedQty) && parsedQty > 0) ? parsedQty : 1
        if (!isFastBuyForm) {
            this.calculatePrice()
        }
    }

    setId(id) {
        this.id = id
    }

    setRopeDiameter(RopeDiameter) {
        this.RopeDiameter = RopeDiameter
    }

    setRopeLength(value) {
        this.ropeLength = value
    }

    blockForm(state) {
        this.observer.publish('disableBuyButton', state)
        this.observer.publish('disableQuantityField', state)
    }

    setCurrencyCode(code) {
        this.currencyCode = code
    }

    resetInput() {
        const input = this.quantityElem.querySelector('input')
        input.value = this.allowDecimalQuantity ? '1.0' : '1'
        this.setQuantity(input.value)
    }

    resetCart() {
        this.resetInput()
        this.setQuantity(1)
        this.setRopeLength(1)
        this._packageSelected = false
        if (this.price) {
            this.setPrice(0)
        }
        this.updateMessage(VARIANTS_TYPES.DEFAULT)
        this.blockForm(true)
    }

    showLoader() {
        this.updateMessage(VARIANTS_TYPES.LOADING)
    }

    hideLoader(){

    }
    setButtonLabel(type) {
        const labels = {
            [VARIANTS_TYPES.BUY]: window.globals.trans('filter.add_to_cart'),
            [VARIANTS_TYPES.QUOTE]: window.globals.trans('filter.add_to_quote'),
        }

        this.addButtonElem.innerHTML = labels[type] || ''
    }

    setButtonState(state) {
        this.addButtonElem.disabled = state
        this.addRentalButton.disabled = state
    }

    checkVariant() {
        const variantSelects = document.querySelectorAll('#attributes-filters select')
        variantSelects.forEach((select) => {
            if (!select.value) {
                const parentElem = select.closest('.selectric-wrapper')
                parentElem.classList.add('error')
            }
        })
    }

    checkSwrData(form) {
        const endingA = form.querySelector('select#rope_ending_a')
        const endingB = form.querySelector('select#rope_ending_b')
        const ropeLength = form.querySelector('input#rope_length')
        const packagingType = form.querySelector('select#packing_type')

        const elementsWithErrors = form.querySelectorAll('.error')
        elementsWithErrors.forEach((elem) => {
            elem.classList.remove('error')
        })

        if (endingA.value !== '' && endingB.value !== '' && ropeLength.value !== '' && packagingType.value !== '') {
            return {
                product: this.id,
                swrDiameter: this.RopeDiameter,
                quantity: this.quantity,
                rope_ending_a: endingA.value,
                rope_length: ropeLength.value,
                rope_ending_b: endingB.value,
                packing_type: packagingType.value,
                IsRentalBtn: this.IsRentalBtn,
            }
        } else {
            if (endingB.value === '') {
                const elem = endingB.closest('.selectric-wrapper')
                elem.classList.add('error')
            }
            if (endingA.value === '') {
                const elem = endingA.closest('.selectric-wrapper')
                elem.classList.add('error')
            }
            if (ropeLength.value === '') {
                ropeLength.classList.add('error')
            }
            if (ropeLength.value === '') {
                ropeLength.classList.add('error')
            }
            if (packagingType.value === '') {
                const elem = packagingType.closest('.selectric-wrapper')
                elem.classList.add('error')
            }
        }

        return false
    }

    sendSwr(form) {
        const data = this.checkSwrData(form)
        if (typeof data == 'object') {
            this.postData(data)
        }
    }

    sendQuote(form) {
        if (form) {
            const data = this.checkSwrData(form)
            if (typeof data == 'object') {
                CartManager.addToCartSWR(data)
            }
        } else {
            const quantity = this.quantity.toString()
            const variantId = this.id.toString()
            CartManager.addToCart(variantId, quantity)
        }
    }

    submitForm(e) {
        e.preventDefault()
        const form = document.querySelector('#rope_form')

        if (this.showAddToCart) {
            this.sendSwr(form)
        } else {
            this.sendQuote(form)
        }
    }

    postData(data) {
        this.blockForm(true)
        axios({
            method: 'post',
            url: this.actionURL,
            data: data,
        })
            .then((response) => {
                const data = response.data
                CartManager.updateCoreshopCartCount(data)
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            currency: data.currencyCode || '',
                            items: [
                                {
                                  item_id: data.id.toString(),
                                  item_name: data.name,
                                  price: data.price || '0',
                                  quantity: Number(data.qty),
                                  item_category: data.category || ''
                                }
                            ]
                        },
                    })
                }
                this.blockForm(false)
            })
            .catch((err) => {
                console.log(err)
                this.blockForm(false)
                throw err
            })
    }

    isPackageSelected() {
        const radio = document.querySelector('input[name="price_option"]:checked')
        if (radio) return radio.value === 'package'
        return this._packageSelected
    }

    formatRawPrice(price) {
        if (!price || price <= 0 || !this.currencyCode) return ''
        return new Intl.NumberFormat(this.getLocaleCode(), {
            style: 'currency',
            currency: this.currencyCode,
        }).format(price)
    }

    onPriceOptionChange() {
        if (!this.unitPrice) return
        const input = this.quantityElem.querySelector('input')
        if (this.isPackageSelected()) {
            const packQtyFormatted = this.allowDecimalQuantity ? `${this.packQty}.0` : String(this.packQty)
            this.setQuantity(packQtyFormatted)
            if (input) input.value = packQtyFormatted
        } else {
            this.setQuantity(this.allowDecimalQuantity ? 1.0 : 1)
            if (input) input.value = this.allowDecimalQuantity ? '1.0' : '1'
        }
        this.setPrice(this.unitPrice)
        this.updateMessage(VARIANTS_TYPES.PRICE)
    }

    render() {
        const isRentalField = document.querySelector('#is_rental')
        this.isRental = isRentalField.value;

        let cart = document.createElement('div')
        const wrapperElem = document.createElement('div')
        wrapperElem.classList.add('wrapper')

        this.formElem.id = 'add_to_cart_form'
        this.formElem.method = 'POST'
        this.formElem.noValidate = true

        this.quantityElem.classList.add('quantity')

        const quantityInputElem = document.createElement('input')
        quantityInputElem.type = 'text'
        quantityInputElem.disabled = true

        this.quantityElem.appendChild(quantityInputElem)

        this.addButtonElem.classList.add('add-button')
        this.addButtonElem.addEventListener('click', (e) => {
            this.IsRentalBtn = false
            this.submitForm(e)
        })
        this.setButtonLabel(VARIANTS_TYPES.BUY)
        
        this.infoDiv.classList.add('button-row')
        if (this.isRental == 1) {
            // this.addRentalButton = document.createElement('button')
            this.addRentalButton.classList.add('login-button')
            this.addRentalButton.title = `${window.globals.trans('filter.available_for_rental' )}`
            this.addRentalButton.innerHTML = `${window.globals.trans('filter.available_for_rental' )}`
            this.addRentalButton.addEventListener('click', (e) => {
                this.IsRentalBtn = true
                this.submitForm(e)
            })
        }

        this.loginButtonElem.classList.add('login-button')
        this.loginButtonElem.href = this.loginURL
        this.loginButtonElem.innerHTML = `<p class='show-on-desktop'>${window.globals.trans(
            'filter.log_in_to_webshop',
        )}</p><p class='show-on-mobile'>${window.globals.trans('filter.log_in')}</p>`
        if (this.isLoginPopupActive()) {
            this.loginButtonElem.href = '#'
            this.loginButtonElem.setAttribute('data-toggle', 'modal')
            this.loginButtonElem.setAttribute('data-target', '#loginModal')
        }

        this.priceOptionsElem = document.createElement('div')
        this.priceOptionsElem.style.display = 'none'
        wrapperElem.appendChild(this.priceOptionsElem)

        this.messageElem.classList.add('message')
        this.updateMessage(VARIANTS_TYPES.DEFAULT)

        wrapperElem.appendChild(this.messageElem)
        this.formElem.appendChild(this.quantityElem)
        this.formElem.appendChild(this.addButtonElem)
        if (this.isRental == 1) {
            this.infoDiv.appendChild(this.addRentalButton)
        }
        if (!this.isLogged && this.isWebshopActive && !this.hideLoginWidget) {
            this.infoDiv.appendChild(this.loginButtonElem)
        }
        this.formElem.appendChild(this.infoDiv)
        wrapperElem.appendChild(this.formElem)
        cart.appendChild(wrapperElem)
        this.initQuantityInput()
        this.initObservers()
        return cart
    }

    initQuantityInput() {
        const getPackStep = () => {
            const pq = parseInt(this.packQty, 10)
            if (pq > 1 && this.isPackageSelected()) return pq
            return this.allowDecimalQuantity === '1' ? 0.1 : 1
        }
        quantityInput(
            this.formElem,
            {
                value: this.quantity,
                allowDecimalQuantity: this.allowDecimalQuantity,
                getStep: getPackStep,
                getMin: getPackStep,
            },
            this.observer,
        )
    }

    initObservers() {
        this.observer.subscribe({
            event: 'ropeLength',
            action: (value) => {
                if (this.price) {
                    let ropeLength = parseInt(value)
                    if (isNaN(ropeLength) || ropeLength === 0) {
                        ropeLength = 1
                    }
                    this.setRopeLength(ropeLength)
                    this.calculatePrice()
                    this.updateMessage(VARIANTS_TYPES.PRICE)
                }
            },
        })

        this.observer.subscribe({
            event: 'disableBuyButton',
            action: (state) => {
                this.setButtonState(state)
            },
        })

        this.observer.subscribe({
            event: 'resetCart',
            action: () => {
                this.resetCart()
            },
        })

        this.observer.subscribe({
            event: 'resetQuantityInput',
            action: () => {
                this.resetInput()
            },
        })

        this.observer.subscribe({
            event: 'showPriceLoader',
            action: () => {
                this.showLoader()
            },
        })

        this.observer.subscribe({
            event: 'hidePriceLoader',
            action: () => {
                this.hideLoader()
            },
        })

        this.observer.subscribe({
            event: 'cartQuantity',
            action: ({ quantity, isFastBuyForm }) => {
                let normalizedQty = quantity

                if (this.allowDecimalQuantity === "1") {
                    normalizedQty = String(quantity).replace(',', '.')
                }

                this.setQuantity(normalizedQty, isFastBuyForm)

                if (this.price && !isFastBuyForm) {
                    this.updateMessage(VARIANTS_TYPES.PRICE)
                }
            },
        })

        this.observer.subscribe({
            event: 'activateCart',
            action: (data) => {
                this.resetCart()
                this.setId(data.id)
                this.setCurrencyCode(data.currencyCode)
                this.setRopeDiameter(data.RopeDiameter)

                this.unitPrice = data.unitPrice ?? data.price
                this.packQty = parseInt(data.packQty, 10) || 0
                this.batchPrice = null

                if (data.wasPackageSelected && this.packQty > 1) {
                    this._packageSelected = true
                }

                if (this.priceOptionsElem) {
                    this.priceOptionsElem.style.display = 'none'
                }

                if (this.showAddToCart) {
                    if (this.unitPrice) {
                        this.setPrice(this.unitPrice)
                        this.updateMessage(VARIANTS_TYPES.PRICE)
                    } else {
                        this.updateMessage(VARIANTS_TYPES.NO_PRICE)
                    }
                    this.setButtonLabel(VARIANTS_TYPES.BUY)
                } else {
                    this.updateMessage(VARIANTS_TYPES.NO_PRICE)
                    this.setButtonLabel(VARIANTS_TYPES.QUOTE)
                }

                // Sync quantity input to new variant's PackQty if package is selected
                if (this._packageSelected && this.packQty > 1) {
                    const packQtyFormatted = this.allowDecimalQuantity ? `${this.packQty}.0` : String(this.packQty)
                    this.setQuantity(packQtyFormatted)
                    const input = this.quantityElem.querySelector('input')
                    if (input) input.value = packQtyFormatted
                }

                this.blockForm(false)
            },
        })

        // refresh cart price after fetch unique price
        this.observer.subscribe({
            event: 'updatePrice',
            action: (data) => {
                const { variantId, freshPriceData, success } = data
                const isTargetVariant = variantId === this.id
                if (isTargetVariant && success) {
                    if (this.packQty > 1) {
                        this.unitPrice = freshPriceData.Price
                        this.onPriceOptionChange()
                    } else {
                        this.setPrice(freshPriceData.Price)
                        this.updateMessage(VARIANTS_TYPES.PRICE)
                    }
                }
            },
        })

        $(document).on('change', 'input[name="price_option"]', (e) => {
            this._packageSelected = e.target.value === 'package'
            if (this.unitPrice === null) return
            this.onPriceOptionChange()
        })
    }
}
